import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../data/translations';
import { ArrowRight, ArrowLeft } from 'lucide-react';

const BASE = "https://www.cobras.be/sites/default/files/styles/";

const AmbitionPage = () => {
  const { lang } = useLanguage();
  const { t, get } = useTranslation(lang);
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { window.scrollTo(0,0); setTimeout(()=>setLoaded(true),100); }, []);
  const p = t.ambitionPage;

  return (
    <div className="min-h-screen" style={{background:'#0a0a0a'}}>
      <div className="fixed inset-0 opacity-30 pointer-events-none z-0" style={{backgroundImage:`url("data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E")`,backgroundSize:'256px'}} />
      <div className="relative z-10">
        <div className="pt-28 md:pt-36 pb-8 px-8 md:px-16 lg:px-24">
          <button onClick={()=>navigate('/')} className="inline-flex items-center gap-2 text-gray-400 hover:text-white text-sm font-medium mb-8 transition-colors"><ArrowLeft size={16}/> {get(t.common.home)}</button>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white uppercase tracking-tight italic" style={{opacity:loaded?1:0,transform:loaded?'translateY(0)':'translateY(30px)',transition:'all 0.8s cubic-bezier(0.16,1,0.3,1)'}}>{get(p.title)}</h1>
        </div>

        <div className="px-8 md:px-16 lg:px-24 pb-8">
          <p className="text-xl md:text-2xl font-bold text-white mb-8 max-w-3xl" style={{opacity:loaded?1:0,transition:'all 0.8s ease 0.2s'}}>{get(p.subtitle)}</p>
        </div>

        <div className="px-8 md:px-16 lg:px-24 mb-12 max-w-4xl">
          {get(p.paragraphs).map((par,i)=>(
            <p key={i} className="text-gray-300 text-base md:text-lg leading-relaxed mb-5" style={{opacity:loaded?1:0,transition:`all 0.6s ease ${0.3+i*0.1}s`}}>{par}</p>
          ))}
        </div>

        {/* Image + Bullet Points */}
        <div className="px-8 md:px-16 lg:px-24 mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div className="overflow-hidden rounded-sm">
              <img src={BASE+"text_media_small/public/uploads/images/cobras_website_21.jpg"} alt="" className="w-full object-cover"/>
            </div>
            <div>
              <ul className="space-y-4">
                {get(p.bulletPoints).map((bp,i)=>(
                  <li key={i} className="flex items-start gap-3 text-gray-300">
                    <span className="w-2 h-2 rounded-full mt-2 flex-shrink-0" style={{backgroundColor:'#A855F7'}}/>
                    <span className="text-base md:text-lg">{bp}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Gallery */}
        <div className="px-8 md:px-16 lg:px-24 mb-16 grid grid-cols-1 md:grid-cols-2 gap-4">
          <img src={BASE+"lightbox/public/uploads/images/cobras_website_25_0.jpg"} alt="" className="w-full aspect-[4/3] object-cover rounded-sm"/>
          <img src={BASE+"lightbox/public/uploads/images/cobras_website_20.jpg"} alt="" className="w-full aspect-[4/3] object-cover rounded-sm"/>
        </div>

        {/* Next Step */}
        <div className="px-8 md:px-16 lg:px-24 py-12">
          <h3 className="text-2xl md:text-3xl font-bold text-white italic mb-4">{get(p.nextStep)}</h3>
          <button onClick={()=>navigate('/doordacht-design')} className="inline-flex items-center gap-2 font-bold text-sm tracking-wider uppercase transition-all duration-300 hover:gap-4" style={{color:'#A855F7'}}>
            {get(p.toStep2)} <ArrowRight size={18}/>
          </button>
        </div>

        {/* CTA */}
        <div className="px-8 md:px-16 lg:px-24 py-16 text-center">
          <h2 className="text-3xl md:text-4xl font-black text-white italic mb-8">{get(p.curious)}</h2>
          <button onClick={()=>{ navigate('/contact'); window.scrollTo({top:0}); }} className="inline-flex items-center gap-3 border-2 text-white px-10 py-4 text-sm font-bold tracking-[0.2em] uppercase transition-all duration-500 group" style={{borderColor:'#A855F7'}} onMouseEnter={e=>e.currentTarget.style.backgroundColor='#A855F7'} onMouseLeave={e=>e.currentTarget.style.backgroundColor='transparent'}>
            {get(p.contactUs)} <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1"/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AmbitionPage;
